import { ModalHandler } from '@app-velocity/ui';

import { PrivacyPolicyModalContent } from './components/PrivacyPolicyModalContent';

export const PrivacyPolicyModal = () => {
  return (
    <ModalHandler
      id="privacy-policy"
      channel="users"
    >
      <PrivacyPolicyModalContent />
    </ModalHandler>
  );
};
